import { ChevronLeft, ChevronRight } from "lucide-react";
import { toast } from "react-toastify";

const API_ROOT = (
  process.env.REACT_APP_API_URL || "http://localhost:5000/api"
).replace("/api", "");

function getAssetUrl(path) {

  if (!path) return "";

  // Already a full URL
  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  // Local uploads
  if (path.startsWith("/uploads")) {
    return `${API_ROOT}${path}`;
  }

  return path;
};

function getTimeAgo(date) {
  const diff = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
  if (diff < 30) return 'Just now';
  if (diff < 60) return diff + 's ago';
  if (diff < 3600) return Math.floor(diff / 60) + 'm ago';
  if (diff < 86400) return Math.floor(diff / 3600) + 'h ago';
  if (diff < 604800) return Math.floor(diff / 86400) + 'd ago';
  if (diff < 2592000) return Math.floor(diff / 604800) + 'w ago';
  if (diff < 31536000) return Math.floor(diff / 2592000) + 'mo ago';
  return Math.floor(diff / 31536000) + 'y ago';
}

// Capitalize first letter helper
const capitalize = str => str.charAt(0).toUpperCase() + str.slice(1);

function Pagination({ pagination, onPageChange }) {
  const { page, totalPages, hasNext, hasPrev } = pagination || {};

  console.log({ pagination });
  if (!totalPages || totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-center gap-3 mb-10 mt-5">
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={!hasPrev}
        className="flex items-center gap-1 px-4 py-2 rounded-xl border disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
      >
        <ChevronLeft size={18} />
        Previous
      </button>

      <span className="text-sm text-gray-600 font-medium">
        Page {page} of {totalPages}
      </span>

      <button
        onClick={() => onPageChange(page + 1)}
        disabled={!hasNext}
        className="flex items-center gap-1 px-4 py-2 rounded-xl border disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-50 transition-colors"
      >
        Next
        <ChevronRight size={18} />
      </button>
    </div>
  );
}
function notifyMe(message) {
  if (!("Notification" in window)) {
    // Check if the browser supports notifications
    toast.error("This browser does not support desktop notification");
  } else if (Notification.permission === "granted") {
    // Check whether notification permissions have already been granted;
    // if so, create a notification
    const notification = new Notification(message);
    // …
  } else if (Notification.permission !== "denied") {
    // We need to ask the user for permission
    Notification.requestPermission().then((permission) => {
      // If the user accepts, let's create a notification
      if (permission === "granted") {
        const notification = new Notification(message);
        // …
      }
    });
  }

  // At last, if the user has denied notifications, and you
  // want to be respectful there is no need to bother them anymore.
}

export { getTimeAgo, capitalize, getAssetUrl, Pagination,notifyMe}